export default "__VITE_ASSET__CNWx0sFw__"